import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=626dafa3&scoped=true"
import script from "./ProductModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626dafa3",
  null
  
)

export default component.exports